import HomeNavBar from "@/components/HomeNavBar/HomeNavBar.vue"
import AllPortals from "@/components/GetPortals/PortalsComponent.vue"
import Column from "@/components/Column/Column.vue"
import { get_token } from "@/router";

export default {
  name: 'Board',
  components: {
    HomeNavBar,
    AllPortals,
    Column
  },
  data() {
    return ({
      idCounter: 2,
      buckets: [],
      isAddingBucket: false,
      newBucketTitle: '',
      selected_column_id:null,
    });
  },
  mounted(){
    this.fetch_board_columns();
  },
  methods: {
    getToken() {
            return get_token();
            },
    fetch_board_columns(){
        $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/get_board_columns/`,
                method: 'POST',
                headers: {
                'Authorization': `Token ${this.getToken()}`,
                'Content-Type': 'application/json'
                },
                data: JSON.stringify({board_id: this.$route.params.board_id }),
                success: (response) => {
                var status = response.status
                if (status == "success") {
                    this.buckets = response.data
                }

                },

                complete: () => {
                this.isLoading = false;
                }
            });
    },
    add_new_column(){
            this.isAddingBucket = true;
            $.ajax({
                    url: `${process.env.VUE_APP_BACKEND_API_URL}/portal_management/create_column/`,
                    method: 'POST',
                    headers: {
                    'Authorization': `Token ${this.getToken()}`,
                    'Content-Type': 'application/json'
                    },
                    data: JSON.stringify({board_id: this.$route.params.board_id,name:this.newBucketTitle}),
                    success: (response) => {
                    var status = response.status
                    if (status == "success") {
                        this.buckets.push(response.data)
                        this.newBucketTitle = '';
                        this.isAddingBucket = false;
                    }

                    },

                    complete: () => {
                    this.isLoading = false;
                    }
                });
        },
    startAddingBucket() {
      this.isAddingBucket = true;
      this.newBucketTitle = '';
      this.$nextTick(() => {
        this.$refs.newBucketInput?.focus();
      });
    },
    saveNewBucket() {
      const title = this.newBucketTitle.trim();
      if (title) {
        this.idCounter++;
        this.buckets.push({ id: this.idCounter, title, tasks: [] });
      }
      this.newBucketTitle = '';
      this.isAddingBucket = false;
    },
    addTask(column_id) {
      this.selected_column_id = column_id;
    },
    deleteBucket(index) {
      this.buckets.splice(index, 1);
    },
  }
};